/**
 * Created by hgun0888
 * */

/**
 * React Modules
 */
import { call, put, takeEvery } from 'redux-saga/effects';
/**
 * Custom Modules
 */
import vendorsApi from '../../externals/vendorProxy';
import { receiveErrorInVendorsFetch, receiveErrorInOpcoFetch } from '../actions/errorDialogActions';
import {
  UNABLE_TO_LOAD_VENDORS, UNABLE_TO_LOAD_OPCOS, UNABLE_TO_LOAD_WAREHOUSES, UNABLE_TO_LOAD_VENDORS_BY_ITEM
} from '../../helpers/messageConstant';
import {
  receiveAllVendors,
  receiveAllOpcos,
  REQUEST_ALL_OPCOS,
  receiveVendorBases,
  REQUEST_ALL_VENDORS,
  REQUEST_VENDOR_BASES,
  REQUEST_WAREHOUSES,
  receiveWarehouses,
  receiveVendorsByItem,
  REQUEST_VENDORS_BY_ITEM
} from '../actions/vendorActions';
import { receiveAllVendorsForSegmentDetail } from '../actions/segmentDataActions';
/**
 * Worker Saga: will be fired on Vendor related actions
 */

export function* fetchAllVendors() {
  try {
    const vendors = yield call(vendorsApi.fetchAllVendors);
    yield put(receiveAllVendors(vendors));
    yield put(receiveAllVendorsForSegmentDetail(vendors));
  } catch (e) {
    yield put(receiveErrorInVendorsFetch(UNABLE_TO_LOAD_VENDORS));
  }
}

export function* fetchVendorsByItem({ data }) {
  try {
    const vendors = yield call(vendorsApi.fetchVendorsByItem, data.itemId);
    yield put(receiveVendorsByItem(vendors));
  } catch (e) {
    yield put(receiveErrorInVendorsFetch(UNABLE_TO_LOAD_VENDORS_BY_ITEM));
  }
}

export function* fetchAllOpcos() {
  try {
    const vendors = yield call(vendorsApi.fetchAllOpcos);
    yield put(receiveAllOpcos(vendors));
  } catch (e) {
    yield put(receiveErrorInOpcoFetch(UNABLE_TO_LOAD_OPCOS));
  }
}

export function* fetchAllVendorBases() {
  try {
    const vendors = yield call(vendorsApi.fetchAllVendorBases);
    yield put(receiveVendorBases(vendors));
  } catch (e) {
    yield put(receiveErrorInVendorsFetch(UNABLE_TO_LOAD_VENDORS));
  }
}

export function* fetchWarehouses({ data }) {
  try {
    const warehouses = yield call(vendorsApi.fetchWarehouses, data);
    yield put(receiveWarehouses(warehouses));
  } catch (e) {
    yield put(receiveErrorInOpcoFetch(UNABLE_TO_LOAD_WAREHOUSES));
  }
}
/**
 * Starts vendor related actions
 */
export function* vendorSaga() {
  yield takeEvery(REQUEST_ALL_VENDORS, fetchAllVendors);
  yield takeEvery(REQUEST_ALL_OPCOS, fetchAllOpcos);
  yield takeEvery(REQUEST_VENDOR_BASES, fetchAllVendorBases);
  yield takeEvery(REQUEST_WAREHOUSES, fetchWarehouses);
  yield takeEvery(REQUEST_VENDORS_BY_ITEM, fetchVendorsByItem);
}
